// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.fermentation_outcome_enum */
var FermentationOutcomeEnum;
(function (FermentationOutcomeEnum) {
    FermentationOutcomeEnum["OK"] = "OK";
    FermentationOutcomeEnum["CONTAMINATED"] = "CONTAMINATED";
    FermentationOutcomeEnum["FAILED"] = "FAILED";
    FermentationOutcomeEnum["MINOR_ISSUES"] = "MINOR_ISSUES";
})(FermentationOutcomeEnum || (FermentationOutcomeEnum = {}));
;
export default FermentationOutcomeEnum;
/** Zod schema for fermentation_outcome_enum */
export const fermentationOutcomeEnum = z.nativeEnum(FermentationOutcomeEnum);
//# sourceMappingURL=FermentationOutcomeEnum.js.map